import { Component, Input, OnInit } from '@angular/core';

import { StoreStatus } from '@shared/models';

import { environment } from '../../../../../environments/environment';
import { STORE_DEVICE } from '../enum/store';

@Component({
  selector: 'app-store-device',
  templateUrl: './store-device.component.html',
  styleUrls: ['./store-device.component.scss']
})
export class StoreDeviceComponent implements OnInit {
  @Input() data: { storeNo?: string; merchant?: string };
  @Input() version: number;
  @Input() storeStatus: StoreStatus;

  env = environment.viewStore;
  device = STORE_DEVICE;
  maxDevicesPOS = 5;
  maxDevicesHand = 10;
  maxDevicesBuddy = 10;
  constructor() {}

  ngOnInit(): void {}
}
